<div class="pre-header" [innerHTML]="data.text" [style]="'background: ' + data.background_color + '; color: ' + data.text_color + ';'"></div>
